import { useCallback, useEffect, useState } from "react";
import { Store } from "lucide-react";
import { api } from "@/lib/api";
import { useAgencyWorkspace } from "@/context/AgencyWorkspaceContext";
import Pipeline from "@/pages/salon/Pipeline";
import ContactDrawer from "@/pages/admin/agency/ContactDrawer";
import AgencyAgendaModal from "@/pages/admin/agency/AgencyAgendaModal";

export default function AgencyPipelinePage() {
  const { selectedTenant } = useAgencyWorkspace();
  const [cases, setCases] = useState({});
  const [drawerClientId, setDrawerClientId] = useState(null);
  const [showAgenda, setShowAgenda] = useState(false);
  const [reloadSignal, setReloadSignal] = useState(0);

  const loadCases = useCallback(() => {
    if (!selectedTenant) { setCases({}); return () => {}; }
    let ignore = false;
    api.get(`/agency/cases?tenant_id=${selectedTenant.id}&status=active`)
      .then((r) => {
        if (ignore) return; // tenant cambiato durante la richiesta → scarta
        const m = {};
        (r.data || []).forEach((row) => {
          const c = row.case;
          if (c?.client_id) m[c.client_id] = c;
        });
        setCases(m);
      })
      .catch(() => { if (!ignore) setCases({}); });
    return () => { ignore = true; };
  }, [selectedTenant]);

  useEffect(() => loadCases(), [loadCases]);

  // Cambio tenant con drawer aperto → chiudi il drawer (no dati salone precedente)
  useEffect(() => { setDrawerClientId(null); }, [selectedTenant?.id]);

  const handleUpdated = () => {
    setReloadSignal((n) => n + 1); // ricarica board senza refresh pagina
    loadCases();                   // aggiorna eventuali badge Agency Case
  };

  if (!selectedTenant) {
    return (
      <div data-testid="aw-pipeline-empty" className="sp-card p-10 text-center">
        <Store className="h-10 w-10 mx-auto text-[color:var(--sp-text-muted)] mb-3" />
        <h2 className="font-display text-xl font-black">Seleziona un salone</h2>
        <p className="text-sm text-[color:var(--sp-text-muted)] mt-2">Scegli un salone dal selettore in alto per vedere la sua pipeline.</p>
      </div>
    );
  }

  return (
    <div data-testid="aw-pipeline-page">
      <Pipeline key={selectedTenant.id} agency agencyCases={cases}
        tenantName={selectedTenant.name}
        onOpenAgenda={() => setShowAgenda(true)}
        reloadSignal={reloadSignal} onOpenClient={(c) => setDrawerClientId(c.id)} />
      {drawerClientId && (
        <ContactDrawer
          clientId={drawerClientId}
          tenant={selectedTenant}
          caseObj={cases[drawerClientId]}
          onClose={() => setDrawerClientId(null)}
          onUpdated={handleUpdated}
        />
      )}
      {showAgenda && (
        <AgencyAgendaModal tenant={selectedTenant}
          onClose={() => { setShowAgenda(false); handleUpdated(); }} />
      )}
    </div>
  );
}
